<script>
export default {
  name: "DetailDescriptions",
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    column: {
      type: Number,
      default: 2,
    },
  },
  render() {
    return (
      <el-descriptions class="detail-descriptions" border column={this.column}>
        {this.data.map((child, index) => {
          if (child.hide === true) {
            return "";
          }

          if (child.title) {
            return (
              <el-descriptions-item
                labelClassName={"custom-label-title"}
                label={child.title}
                span={this.column}
                key={index}
              ></el-descriptions-item>
            );
          }

          return (
            <el-descriptions-item
              label={child.label}
              key={index}
              span={child.span}
            >
              {!child.default
                ? child.format
                  ? child.format(child.value)
                  : child.value
                : child.default()}
            </el-descriptions-item>
          );
        })}
      </el-descriptions>
    );
  },
};
</script>
<style lang="scss" scoped >
.detail-descriptions {
  :deep(.custom-label-title) {
    background-color: #fff;
    color: #000;
    font-weight: 600 !important;
    border: none !important;
    & ~ td {
      border: none !important;
    }
  }
  :deep(.custom-label-title ~ td) {
    border: none !important;
  }
}
</style>
